/* Montalore product page upgrade: keeps the USP rows in sync with the selected variant.
   - Klarna amount = price / 3 (rounded down to the cent), row hidden outside the min/max range
   - Delivery line switches between stock / preorder / soldout
   Listens to Prestige's bubbling "variant:change" event (detail.variant). */
(() => {
  if (window.__mtlPdpInit) return;
  window.__mtlPdpInit = true;

  const formatMoney = (cents, format) => {
    const fmt = format || '€{{amount_with_comma_separator}}';
    const value = (cents / 100).toFixed(2);
    const [whole, dec] = value.split('.');
    const withSep = (w, sep) => w.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return `${withSep(whole, ',')}.${dec}`;
        case 'amount_no_decimals': return withSep(String(Math.round(cents / 100)), ',');
        case 'amount_with_comma_separator': return `${withSep(whole, '.')},${dec}`;
        case 'amount_no_decimals_with_comma_separator': return withSep(String(Math.round(cents / 100)), '.');
        case 'amount_with_apostrophe_separator': return `${withSep(whole, "'")}.${dec}`;
        default: return `${whole},${dec}`;
      }
    });
  };

  const update = (variantId) => {
    document.querySelectorAll('[data-mtl-usp]').forEach((root) => {
      let variants = {};
      try { variants = JSON.parse(root.querySelector('[data-mtl-variants]').textContent); } catch (e) { return; }
      const v = variants[String(variantId)];
      if (!v) return;

      // Row, drawer and Shipping accordion all switch with the variant's stock state.
      // data-mtl-state can list several states ("stock soldout"). Drawers move to <body>, so search the document.
      document.querySelectorAll('[data-mtl-state]').forEach((el) => {
        el.hidden = !el.getAttribute('data-mtl-state').split(' ').includes(v.state);
      });

      const klarna = root.querySelector('[data-mtl-klarna]');
      if (klarna) {
        const min = parseInt(root.dataset.klarnaMin || '0', 10);
        const max = parseInt(root.dataset.klarnaMax || '0', 10);
        klarna.hidden = (min > 0 && v.price < min) || (max > 0 && v.price > max);
        // Row + drawer title (the drawer is moved to <body> when opened, so search the whole document)
        const text = formatMoney(Math.floor(v.price / 3), root.dataset.moneyFormat);
        document.querySelectorAll('[data-mtl-klarna-amount]').forEach((el) => { el.textContent = text; });
      }
    });
  };


  // FD Product Groups app renders its swatch label as "Color: <value>" in English only.
  // Swap the leading "Color:" for the translated label (theme locale mtl_pdp.option_color).
  const translateColorLabel = () => {
    const root = document.querySelector('[data-mtl-usp][data-color-label]');
    if (!root) return;
    const label = root.dataset.colorLabel;
    document.querySelectorAll('.fd-options-swatch label > div').forEach((el) => {
      const m = el.textContent.match(/^\s*colou?r\s*:\s*(.*)$/i);
      if (m && !el.dataset.mtlTranslated) {
        el.textContent = `${label} ${m[1]}`;
        el.dataset.mtlTranslated = '1';
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', translateColorLabel);
  else translateColorLabel();
  new MutationObserver(() => translateColorLabel()).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    if (variant && variant.id) update(variant.id);
  });
})();
